package pl.decks.personal.components.widgets.disclaimer

import androidx.compose.runtime.Composable
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.setValue
import com.varabyte.kobweb.compose.css.Cursor
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.foundation.layout.Spacer
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.cursor
import com.varabyte.kobweb.compose.ui.modifiers.onClick
import com.varabyte.kobweb.silk.components.icons.fa.FaChevronDown
import com.varabyte.kobweb.silk.components.icons.fa.FaChevronUp
import com.varabyte.kobweb.silk.components.icons.fa.FaCircleExclamation
import com.varabyte.kobweb.silk.components.text.SpanText
import com.varabyte.kobweb.silk.style.toModifier
import pl.decks.personal.components.widgets.LeadingIconRow

@Composable
fun DisclaimerBox(
    modifier: Modifier = Modifier,
    content: @Composable () -> Unit
) {
    var isOpen by remember { mutableStateOf(false) }
    Column(
        modifier = DisclaimerBoxStylesheet.Container.Base
            .toModifier(
                if (isOpen) DisclaimerBoxStylesheet.Container.OpenVariant
                else DisclaimerBoxStylesheet.Container.ClosedVariant
            )
            .then(modifier)
            .cursor(Cursor.Pointer)
            .onClick { isOpen = !isOpen },
        horizontalAlignment = Alignment.CenterHorizontally,
    ) {
        LeadingIconRow(
            icon = { FaCircleExclamation(DisclaimerBoxStylesheet.ControlIcon.toModifier()) },
            modifier = DisclaimerBoxStylesheet.Heading.toModifier(),
        ) {
            SpanText("Disclaimer", modifier = DisclaimerBoxStylesheet.Title.toModifier())
            Spacer()
            if (isOpen) FaChevronUp(DisclaimerBoxStylesheet.ControlIcon.toModifier())
            else FaChevronDown(DisclaimerBoxStylesheet.ControlIcon.toModifier())
        }
        if (isOpen) {
            content()
        }
    }
}
